import {
	ApiClientManager,
	GetDocumentsInputDto,
	GetDocumentsOutputDtoSingleOutputMessage,
} from '@api/consumerloans-public-api';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useFetch } from '@hooks';
import { useLoadingStore, usePTCMetadata, useServicesStore } from '@store';

export const useFetchGetDocuments = (): UseFetchHookOutput<
	GetDocumentsInputDto,
	GetDocumentsOutputDtoSingleOutputMessage
> => {
	const saveServiceResponse = useServicesStore((state) => state.saveServiceResponse);
	const metadata = usePTCMetadata();
	const setIsLoadingGetDocuments = useLoadingStore((state) => state.setIsLoadingGetDocuments);
	const applicationContextId = useServicesStore((state) => state.init?.applicationContextId);

	return useFetch<GetDocumentsInputDto, GetDocumentsOutputDtoSingleOutputMessage>({
		fetchFn: (data: GetDocumentsInputDto) => {
			setIsLoadingGetDocuments(true);
			return ApiClientManager.call.getDocuments({ data: { ...data, metadata, applicationContextId } });
		},
		onSuccess: (res: GetDocumentsOutputDtoSingleOutputMessage) => {
			if (res.data) {
				setIsLoadingGetDocuments(false);
				saveServiceResponse({ getDocuments: res.data || {} });
			}
		},
		onError: () => {
			setIsLoadingGetDocuments(false);
		},
		notShowLoading: true,
	});
};
